/**
 * Enum para identificar a fonte/origem do evento
 * Deve estar sincronizado com o backend
 */
export enum EventSource {
  DONATION = 'DONATION',
  SALE = 'SALE',
  TWITCH_SUB = 'TWITCH_SUB',
  KICK_SUB = 'KICK_SUB',
  TWITCH_BITS = 'TWITCH_BITS',
  KICK_KICKS = 'KICK_KICKS',
  YOUTUBE_MEMBER = 'YOUTUBE_MEMBER',
  YOUTUBE_SUPERCHAT = 'YOUTUBE_SUPERCHAT',
}

/**
 * Interface para metadados de eventos recebidos via WebSocket
 * Usado para exibir notificações no Rhynothon/Goals
 */
export interface EventMetadata {
  /** Fonte do evento (doação, venda, sub, etc) */
  source: EventSource;

  /** Nome da pessoa que contribuiu */
  contributorName: string;

  // Valores financeiros
  /** Valor em centavos (para donations/sales) */
  amountInCents?: number;

  // Subscriptions
  /** Tier da subscription (1000, 2000, 3000) */
  tier?: string;

  /** Quantidade (para gift subs) */
  quantity?: number;

  /** Se é um gift sub */
  isGift?: boolean;

  // Tempo (para Rhynothon)
  /** Tempo adicionado em segundos */
  timeAddedSeconds?: number;
}
